import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";

// Strong-password rules for setting/creating a password.
export const PW_RULES = [
  { key: "len", label: "At least 8 characters", test: (p) => p.length >= 8 },
  { key: "upper", label: "An uppercase letter", test: (p) => /[A-Z]/.test(p) },
  { key: "lower", label: "A lowercase letter", test: (p) => /[a-z]/.test(p) },
  { key: "num", label: "A number", test: (p) => /\d/.test(p) },
  { key: "special", label: "A special character", test: (p) => /[^A-Za-z0-9]/.test(p) },
];
export const pwStrong = (p) => PW_RULES.every((r) => r.test(p || ""));

export function PasswordStrength({ password }) {
  if (!password) return null;
  return (
    <ul className="mt-3 grid grid-cols-2 gap-x-4 gap-y-1">
      {PW_RULES.map((r) => {
        const ok = r.test(password);
        return (
          <li key={r.key} className={`font-mono text-[10px] flex items-center gap-1.5 ${ok ? "text-[hsl(var(--accent))]" : "text-muted-foreground"}`}>
            <span>{ok ? "✓" : "○"}</span>{r.label}
          </li>
        );
      })}
    </ul>
  );
}

// Password input with a show/hide toggle and an optional strength checklist.
export default function PasswordField({
  value, onChange, placeholder, autoComplete = "new-password",
  strength = false, className = "underline-input w-full", ...rest
}) {
  const [show, setShow] = useState(false);
  return (
    <div>
      <div className="relative">
        <input type={show ? "text" : "password"} value={value} onChange={onChange}
          placeholder={placeholder} autoComplete={autoComplete} className={`${className} pr-9`} {...rest} />
        <button type="button" onClick={() => setShow((v) => !v)} aria-label={show ? "Hide password" : "Show password"}
          className="absolute right-0 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-foreground p-1">
          {show ? <EyeOff size={16} strokeWidth={1.5} /> : <Eye size={16} strokeWidth={1.5} />}
        </button>
      </div>
      {strength && <PasswordStrength password={value} />}
    </div>
  );
}
